import Layout from '../components/layout'

import dynamic from 'next/dynamic';
const Footer = dynamic(() => import('../components/pages/common/footerWidget'));
import DesktopWidget from "../components/pages/contact-us/deskproWidget"

export default function ContactUs() {
    const contactUs = <div className="main-contact-container">
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <div className="cont-detail">
                    <div className="">
                        <h2>Contact Us</h2>
                        <p>Have a question about filing your tax extension with us? As an authorized e file provider,
it is our duty to help you file your extension as quickly & easily as possible.</p>
                    </div>
                </div>
            </div>
        </div>
        <DesktopWidget />
    </div>
</div> 
    return (
        <Layout preHeader={contactUs}>                       
        <Footer/>
        </Layout>
    )
}
